/**
 * HFBD-7a: column keys the hierarchical table introduces itself.
 *
 * These are not metadata fields: none has a single field to bind, to sort on, or to translate a label
 * from. Keeping them out of {@link MetadataField} is also what keeps them out of the column-filter and
 * sort machinery, which reads a column's key as a field.
 */
export enum HierarchyColumn {
    StukFormats = 'StukFormats',
    StukCount = 'StukCount',
    Parent = 'Parent'
}
